import { PleatedBlindInitService } from './pleated-blind-init.service';
import { PleatedBlindActionTypes } from './pleated-blind.actions';
import { pleatedBlindQuery } from './pleated-blind.selectors';
import { map, withLatestFrom } from 'rxjs/operators';
import { PleatedBlindState } from './pleated-blind.reducer';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { fromSharedActions, SharedActionTypes, ConfiguratorsDataLoaded } from '@icc/configurator/shared';

@Injectable()
export class PleatedBlindEffects {


    changedConfiguration$ = createEffect(() => this.actions$.pipe(
        ofType(
            PleatedBlindActionTypes.SetPleatedBlindShape,
            PleatedBlindActionTypes.SetPleatedBlindSystem,
            PleatedBlindActionTypes.SetPleatedBlindVariant,
            PleatedBlindActionTypes.SetPleatedBlindMainFabric,
            PleatedBlindActionTypes.SetPleatedBlindAdditionalFabric,
            PleatedBlindActionTypes.SetPleatedBlindProfilesColor,
            PleatedBlindActionTypes.SetPleatedBlindDrive,
            PleatedBlindActionTypes.SetPleatedBlindDriveSide,
            PleatedBlindActionTypes.SetPleatedBlindGuidanceType,
            PleatedBlindActionTypes.SetPleatedBlindClosureType,
        ),
        withLatestFrom(this.store.pipe(select(pleatedBlindQuery.getPleatedBlindConfiguration))),
        map(([action, configuration]) => {
            return new fromSharedActions.ConfigurationChanged({
                configuration
            });
        })
    ))


    configuratorsDataLoaded$ = createEffect(() => this.actions$.pipe(
        ofType<ConfiguratorsDataLoaded>(SharedActionTypes.ConfiguratorsDataLoaded),
        map(action => action.payload),
        map(payload => {
            if (payload.data) {
                this.pleatedBlindInitService.init();
            }
        })
    ), {
        dispatch: false
    });

    constructor(
        private actions$: Actions,
        private store: Store<PleatedBlindState>,
        private pleatedBlindInitService: PleatedBlindInitService,
    ) {}
}
